import React from "react";
import { motion } from "framer-motion";
import { FaHtml5, FaReact, FaSass, FaFigma } from "react-icons/fa";
import { DiCss3, DiJavascript1, DiNodejs } from "react-icons/di";
import {
  SiJest,
  SiMocha,
  SiTestinglibrary,
  SiExpress,
  SiMongodb,
  SiTypescript,
} from "react-icons/si";

import "./Skills.scss";
// import { SkillData } from "./SkillData";

function Skills() {
  return (
    <motion.div
      whileInView={{ y: [-100, 0], opacity: [0, 1] }}
      transition={{ duration: 0.7 }}
      id="skills"
      className="skills"
    >
      <div className="skills_section">
        <h1 className="skills_title">Skills</h1>
        <div className="skill_list">
          <div className="skill_item">
            <div className="skill">
              <FaHtml5 className="skill_icon" />
              <span>HTML</span>
            </div>
          </div>
          <div className="skill_item">
            <div className="skill">
              <DiCss3 className="skill_icon" />
              <span>CSS3</span>
            </div>
          </div>
          <div className="skill_item">
            <div className="skill">
              <DiJavascript1 className="skill_icon" />
              <span>Javascript</span>
            </div>
          </div>
          <div className="skill_item">
            <div className="skill">
              <SiTypescript className="skill_icon" />
              <span>Typescript</span>
            </div>
          </div>
          <div className="skill_item">
            <div className="skill">
              <FaReact className="skill_icon" />
              <span>React</span>
            </div>
          </div>
        </div>
        <div className="skill_list">
          <div className="skill_item">
            <div className="skill">
              <DiNodejs className="skill_icon" />
              <span>NodeJs</span>
            </div>
          </div>
          <div className="skill_item">
            <div className="skill">
              <SiMongodb className="skill_icon" />
              <span>MongoDB</span>
            </div>
          </div>
          <div className="skill_item">
            <div className="skill">
              <FaSass className="skill_icon" />
              <span>Sass</span>
            </div>
          </div>

          <div className="skill_item">
            <div className="skill">
              <SiExpress className="skill_icon" />
              <span>Express</span>
            </div>
          </div>
        </div>
        <div className="skill_list">
          <div className="skill_item">
            <div className="skill">
              <SiTestinglibrary className="skill_icon" />
              <span>
                Testing <br /> Library
              </span>
            </div>
          </div>
          <div className="skill_item">
            <div className="skill">
              <SiJest className="skill_icon" />
              <span>Jest</span>
            </div>
          </div>
          <div className="skill_item">
            <div className="skill">
              <SiMocha className="skill_icon" />
              <span>Mocha</span>
            </div>
          </div>

          <div className="skill_item">
            <div className="skill">
              <FaFigma className="skill_icon" />
              <span>Figma</span>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
}

export default Skills;
